import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import clsx from 'clsx';

/**
 *  Generates a checkbox element
 *
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Checkbox = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    checked = false,
    label,
    labelClassName,
    onChange = () => {},
    secondaryLabel,
    ...rest
  } = _ref;
  const [isChecked, setIsChecked] = useState(checked);
  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);
  const handleChange = event => {
    event.persist();
    setIsChecked(state => !state);
    onChange(event);
  };
  const secondLabel = secondaryLabel && /*#__PURE__*/_jsx("div", {
    className: "text-normal",
    children: secondaryLabel
  });
  const labelClassNames = clsx({
    checkbox: true
  }, labelClassName);
  return /*#__PURE__*/_jsxs("label", {
    className: labelClassNames,
    "data-cmp": "checkbox",
    children: [/*#__PURE__*/_jsx("input", {
      ref: input => ref && ref.current.push(input),
      type: "checkbox",
      onChange: handleChange,
      checked: isChecked,
      ...rest
    }, label), label && /*#__PURE__*/_jsx("div", {
      className: "input-label",
      children: label
    }), secondLabel && /*#__PURE__*/_jsx("div", {
      className: "input-secondary-label",
      children: secondLabel
    })]
  });
});
export default Checkbox;